var map = {
	"./i18n/options.i18n.en-us.js": "2RqR",
	"./i18n/ors-dictionary.i18n.en-us.js": "RBhU",
	"./i18n/ors-map-filters.i18n.en-us.js": "YLhA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1g1a";